import { useState, useContext, useEffect } from 'react';
import { GridColDef, GridRenderCellParams, GridRowParams, GridRowSelectionModel } from '@mui/x-data-grid';
import Table from '../custom/Table';
import { Button, IconButton, Tooltip, Stack, TextField, Box, FormControl, Select, MenuItem, Chip, OutlinedInput, SelectChangeEvent } from "@mui/material";
import Modal from '../Modals';
import VisibilityIcon from '@mui/icons-material/Visibility';
import useService from '../../hooks/useService';
import { InventoryContext } from '../../contexts/InventoryContext';
import { AuthContext } from '../../contexts/AuthContext';
import moment from 'moment';
import { createOrUpdateStockRequest, createStockTransferOrder, fetchInventory, getStockRequest } from '../../services/Inventory';
import { NotificationContext } from '../../contexts/NotificationContext';
import { TReqIncomoingInventory, MyObject, TStockReqDetail } from '../../Models/Inventory';
import styled from 'styled-components';
import { IStocktranferData } from '../../services/Inventory/types';
import { MenuProps, MetalImage } from './CreateStockModal';
import { nanoid } from 'nanoid'
import { REQUEST_STATUS } from '../../utils/constant';

const Container = styled.div`
  width: 1200px !important;
  padding: '0 10px';
`
const INCOMING_REQUEST_TABLE = [
    {
        id: 'action',
        label: 'Action',
    },
    {
        id: 'requestorCenter',
        label: 'Requestor Center',
    },
    {
        id: 'requestedCenter',
        label: 'Requested Center',
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'createdAt',
        label: 'Created At',
    },
    {
        id: 'updatedAt',
        label: 'Updated At',
    },
]

export const SHOW_REQUEST_TABLE = [
    {
        id: 'action',
        label: 'Action',
    },
    {
        id: 'productName',
        label: 'Product Name',
    },
    {
        id: 'metalType',
        label: 'Metal Type',
    },
    {
        id: 'quantity',
        label: 'Quantity',
    },
    {
        id: 'createdAt',
        label: 'Created At',
    },
    {
        id: 'updatedAt',
        label: 'Updated At',
    },

]

const REQ_INVENTORY_SHOWCASE = [
    {
        id: "image",
        label: 'Image',
    },
    {
        id: "name",
        label: 'Product Name',
    },
    {
        id: "metalType",
        label: 'Metal Type',
    },
    {
        id: "quantity",
        label: 'Quantity',
    },
    {
        id: "reqQuantity",
        label: 'Request Quantity',
    },
    {
        id: "skuId",
        label: 'SKU Id',
    },
    {
        id: "unitWeight",
        label: 'Unit Weight (gm)',
    },
    {
        id: "currentFineWeight",
        label: 'Fine Weight (gm)'
    },
    {
        id: "dimensions",
        label: 'Dimension',
    },
    {
        id: "shape",
        label: 'Shape',
    },
    {
        id: "purity",
        label: 'Purity',
    },
    {
        id: "selectedSerialNumbers",
        label: 'Serial Numbers',
    },
]

export const IncomingRequest = () => {

    const { execute } = useService()
    const { stockRequest } = useContext(InventoryContext)
    const { user } = useContext(AuthContext)
    const [showStockRequestDetail, setShowStockRequestDetail] = useState<boolean | TStockReqDetail>(false)
    const [currentRequest, setCurrentRequest] = useState({})
    // eslint-disable-next-line array-callback-return
    const showRequest = stockRequest.filter((stock) => {
        if (stock.requestedCenter === user.centerId) return stock
    })

    const handleChange = (params: any) => {
        setShowStockRequestDetail(params.row.lineItem)
        setCurrentRequest(params.row)
    }

    const getStockRequests = () => {
        return INCOMING_REQUEST_TABLE.map(field => {

            const row: GridColDef = {
                field: field.id,
                headerName: field.label,
                minWidth: 200,
                align: 'left'
            }

            switch (field.id) {
                case "action":
                    row.minWidth = 150;
                    row.renderCell = params => {
                        return <>{params.row.id ?
                            <Tooltip title='confirm request'>
                                <IconButton style={{ marginLeft: '-10px' }} onClick={() => handleChange(params)}><VisibilityIcon /></IconButton>

                            </Tooltip> : "NA"
                        }</>
                    }
                    break;
                case "requestorCenter":
                    row.minWidth = 190;
                    break;
                case "requestedCenter":
                    row.minWidth = 190;
                    break;
                case "status":
                    row.minWidth = 170;
                    break;
                case "createdAt":
                    row.minWidth = 200;
                    row.renderCell = params => {
                        return params.row.updatedAt ? moment(params.row.createdAt).clone().utcOffset('+05:30').format('hh:mm a, Do MMM, YYYY') : "NA"
                    }
                    break;
                case "updatedAt":
                    row.minWidth = 200;
                    row.renderCell = params => {
                        return params.row.updatedAt ? moment(params.row.updatedAt).clone().utcOffset('+05:30').format('hh:mm a, Do MMM, YYYY') : "NA"
                    }
                    break;
                    
            }

            return row;
        })
    }
    useEffect(() => {
        execute(() => fetchInventory({ channelId: user.centerId! || '' }))
    }, [])

    const closeStockDetails = () => {
        setShowStockRequestDetail(false)
    }

    return (
        <div style={{ padding: '0 10px' }}>
            <Table columns={getStockRequests()} rows={showRequest ?? []} />
            <Modal open={typeof showStockRequestDetail != 'boolean'} title={'View Details'} onClose={closeStockDetails} maxWidth={'xl'}>
                <ShowStockDetails currentRequest={currentRequest} data={showStockRequestDetail} onClose={closeStockDetails} />
            </Modal>
        </div>
    )
}


export function ShowStockDetails({ currentRequest, data, onClose }: { currentRequest: any, data: any, onClose: any }) {
    const { user } = useContext(AuthContext)
    const { inventories } = useContext(InventoryContext)
    const { notify } = useContext(NotificationContext);
    const { execute } = useService()

    const [totalGoldFineWeight, setTotalGoldFineWeight] = useState<number>(0)
    const [totalSilverFineWeight, setTotalSilverFineWeight] = useState<number>(0)
    const [isDisabled, setIsDisabled] = useState(false)

    useEffect(() => {
        handleSelection()
        if (currentRequest.status !== REQUEST_STATUS.PENDING)
            setIsDisabled(true)
    }, [])

    useEffect(() => {
        let updatedRow: TReqIncomoingInventory[] = []

        rows.length > 0 && rows.forEach((row: TReqIncomoingInventory) => {
            delete row['transferredWeight']
            delete row['transferredQuantity']
            updatedRow.push(row as TReqIncomoingInventory)
        })
        setRows(updatedRow as TReqIncomoingInventory[])
    }, [])

    let output: any = [];

    const initiateRowData = () => {
        // Iterate over lineItem array in req
        currentRequest.lineItem?.forEach((item: any) => {
            // Find matching skuId in inv
            let matchingInvItem = inventories.data?.find(invItem => invItem.skuId === item.skuId);
            if (matchingInvItem) {
                // Construct the output object
                let outputItem = {
                    ...matchingInvItem,
                    reqQuantity: item.reqQuantity,
                    weight: item.weight,
                    purity: item.purity,
                    fineWeight: item.fineWeight,
                    createdAt: item.createdAt,
                    updatedAt: item.updatedAt,
                    stoReqLineItemId : item.id
                };
                output.push(outputItem);
            }
        });
    }
    initiateRowData()

    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
    const [rows, setRows] = useState<TReqIncomoingInventory[]>(output as TReqIncomoingInventory[]);

    
      const MultipleSelectBox = ({serialNumbers, params}: {serialNumbers: number[], params: any}) => {
        const handleChange = (event: SelectChangeEvent<typeof params.selectedSerialNumbres>) => {
            const { target: { value } } = event
            
            params['selectedSerialNumbers'] = value
            let updatedRows = rows.map((row: TReqIncomoingInventory) => row.id === params.id ? params : row)
            setRows(updatedRows as TReqIncomoingInventory[])
        }

    
        return (
          <FormControl fullWidth size="medium">
            <Select
              required
              multiple
              disabled={!params.reqQuantity || (params.selectedSerialNumbers && Number(params.selectedSerialNumbers?.length) >= Number(params.reqQuantity))}
              value={params.selectedSerialNumbers ?? []}
              onChange={handleChange}
              input={<OutlinedInput/>}
              renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value: any) => (
                  <Chip key={value} label={value} />
                ))}
              </Box>
              )}
              MenuProps={MenuProps}
            >
              {serialNumbers.map((num: any) => (
                <MenuItem
                  key={num}
                  value={num}
                >
                  {num}
                  </MenuItem>
              ))}
            </Select>
          </FormControl>
        )
      }
    
    const handleQuantityTransfer = (e: any, params: GridRenderCellParams) => {
        e.stopPropagation()
        
        let value = e.target.value
        if (Number(value) < 0) value = 0

        let updatedRows: TReqIncomoingInventory[] = []

        rows.forEach((row: any) => {
            let { id, metalType, unitWeight, fineWeight, quantity, reqQuantity } = row

            if (params.row.id === id) {
                if (Number(value) > Number(quantity)) {
                    row['reqQuantity'] = quantity
                    row['transferredWeight'] = +(unitWeight * quantity)
                } else {
                    row['reqQuantity'] = Number(value)
                    row['transferredWeight'] = Number(unitWeight * value)
                }

                if (metalType.toLowerCase() === 'gold') {
                    let goldFineWeight: any = +(reqQuantity * fineWeight);

                    let oldFineWeight = row['goldFineWeight']
                    oldFineWeight = Number(oldFineWeight)


                    if (row['goldFineWeight']) {
                        row['goldFineWeight'] = goldFineWeight
                        let newFineWeight = oldFineWeight + goldFineWeight

                        setTotalGoldFineWeight(Number(newFineWeight.toFixed(4)) as number)
                    } else {
                        row['goldFineWeight'] = goldFineWeight
                        let finalFineWeight = totalGoldFineWeight + goldFineWeight

                        setTotalGoldFineWeight(Number(finalFineWeight.toFixed(4)) as number)
                    }
                } else {
                    let silverFineWeight: any = +(reqQuantity * fineWeight)

                    let oldFineWeight = row['silverFineWeight']
                    oldFineWeight = Number(oldFineWeight)

                    if (row['silverFineWeight']) {
                        row['silverFineWeight'] = silverFineWeight
                        let newFineWeight = oldFineWeight + silverFineWeight

                        setTotalSilverFineWeight(Number(newFineWeight.toFixed(4)) as number)
                    } else {
                        row['silverFineWeight'] = silverFineWeight
                        let finalFineWeight = totalSilverFineWeight + silverFineWeight

                        setTotalSilverFineWeight(Number(finalFineWeight.toFixed(4)) as number)
                    }
                }
                updatedRows.push(row)
            } else {
                updatedRows.push(row)
            }
        })
        setRows(updatedRows)
    }

    const getInventoryColumns = () => {
        let minWidth = 300

        return REQ_INVENTORY_SHOWCASE.map(inboundField => {
            const row: GridColDef = {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth,
                align: 'left',
                editable: false
            }

            switch (inboundField.id) {
                case "image":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        let url = params.row.images && params.row.images.length > 0 ? params.row.images.sort((a: MyObject, b: MyObject) => Number(a.priority) - Number(b.priority))[0].img_url : ''
                        return url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
                    }
                    break;
                case "name":
                    row.minWidth = 550;
                    row.renderCell = params => {
                        return params.row.name ? params.row.name : "NA"
                    }
                    break;
                case "skuId":
                    row.minWidth = 180;
                    row.renderCell = params => {
                        return params.row.skuId ? params.row.skuId : "NA"
                    }
                    break;
                case "unitWeight":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.unitWeight ? params.row.unitWeight : "NA"
                    }
                    break;
                case "currentFineWeight":
                    row.minWidth = 150;
                    row.renderCell = params => {
                        return params.row.currentFineWeight ? params.row.currentFineWeight : "NA"
                    }
                    break;
                case "dimensions":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.dimensions ? params.row.dimensions : "NA"
                    }
                    break;
                case "shape":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.shape ? params.row.shape : "NA"
                    }
                    break;
                case "quantity":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.quantity ? params.row.quantity : "NA"
                    }
                    break;
                case "purity":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.purity ? params.row.purity : "NA"
                    }
                    break;
                case "metalType":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.metalType ? params.row.metalType : "NA"
                    }
                    break;
                case "weight":
                    row.minWidth = 180;
                    row.renderCell = params => {
                        return params.row.unitWeight ? params.row.unitWeight : 'NA'
                    }
                    break;
                case "reqQuantity":
                    row.minWidth = 200;
                    row.type = 'number';
                    row.headerAlign = 'left';
                    row.renderCell = params => {
                        return <>{
                            <TextField
                                size="small"
                                variant="outlined"
                                value={params.row.reqQuantity === 0 ? '' : params.row.reqQuantity}
                                onChange={(e) => handleQuantityTransfer(e, params)}
                                type={'number'}
                                disabled={!rowSelectionModel.includes(params.row.id)}
                                error={params.row.reqQuantity > params.row.quantity}
                                label={params.row.reqQuantity > params.row.quantity && 'Exceeds Available Qty'}
                            />
                        }
                        </>
                    }
                    break;
                    case "selectedSerialNumbers":
                        row.renderCell = params => {
                          let serialNumbers = JSON.parse(params.row.serialNumbers)
                          return <>{
                            params.row.inventoryType === 1 && rowSelectionModel.includes(params.row.id)
                            ? <MultipleSelectBox serialNumbers={serialNumbers} params={params.row} />  
                            : "NA"
                          }</>
                        }
                        break;    
                default:
                    row.minWidth = 100
                    break;
            }
            return row;
        })
    }

    const handleSelection = () => {
        let updatedRow: TReqIncomoingInventory[] = []

        rows.forEach((row: TReqIncomoingInventory) => {
            row['isEditable'] = true
            updatedRow.push(row as TReqIncomoingInventory)
        })
        setRows(updatedRow)
    };

    const clearPreviousRowDetails = () => {
        let updatedRows: TReqIncomoingInventory[] = []

        rows.forEach((row: TReqIncomoingInventory) => {
            // row['silverFineWeight'] = 0
            // row['goldFineWeight'] = 0
            delete row['transferredWeight']
            delete row['transferredQuantity']
            row['selectedSerialNumbers'] = []

            updatedRows.push(row as TReqIncomoingInventory)
        })
        setRows(updatedRows as TReqIncomoingInventory[])
        // setTotalGoldFineWeight(0 as number)
        // setTotalSilverFineWeight(0 as number)

    }

    const handleRowSelectionModel = (newRowSelectionModel: GridRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);

        if (newRowSelectionModel.length > 0) {
            let updatedRow: TReqIncomoingInventory[] = []

            rows.forEach((row: TReqIncomoingInventory) => {
                if (newRowSelectionModel.includes(row.id)) {
                    row['isEditable'] = true
                    updatedRow.push(row as TReqIncomoingInventory)
                }
                else {
                    row['isEditable'] = true
                    // if (row['goldFineWeight']) {
                    //     let updatedFineWeight = totalGoldFineWeight - (row['goldFineWeight'] as number)
                    //     setTotalGoldFineWeight(Number(updatedFineWeight.toFixed(2)))
                    // }

                    // if (row['silverFineWeight']) {
                    //     let updatedFineWeight = totalSilverFineWeight - (row['silverFineWeight'] as number)
                    //     setTotalSilverFineWeight(Number(updatedFineWeight.toFixed(2)))
                    // }
                    delete row['transferredWeight']
                    delete row['transferredQuantity']
                    // delete row['goldFineWeight']
                    // delete row['silverFineWeight']
                    row['selectedSerialNumbers'] = []
                    updatedRow.push(row as TReqIncomoingInventory)
                }
            })
                    setRows(updatedRow)
        } else {
            clearPreviousRowDetails()
        }
    }
    const stockTransferOrder = async () => {
        const editedRow = rows.filter((row: any) => rowSelectionModel.some((id) => id === row.id))

        if (editedRow.length === 0) return notify('select line Item to be confirm', 'error')
    
        for(let row of editedRow) {
            if (row.quantity < row.reqQuantity) return notify(`${row.reqQuantity} Nos. for ${row.name} is Not available in stock`, 'error')
            if (row.inventoryType === 1 && !row.selectedSerialNumbers && row.reqQuantity>0) return notify(`Serial number cannot be empty against the requested quantity`, 'error')
            if (row.inventoryType === 1 && row.selectedSerialNumbers.length !== row.reqQuantity ) return notify(`Serial numbers must matched with the requested quantity`, 'error')
        }

        const lineItem = editedRow.map(item => {
            let weightChange = Number(item.currentWeight / item.quantity) * item.reqQuantity
            let fineWeightChange = Number(item.currentFineWeight / item.quantity) * item.reqQuantity

            return {
                ...item,
                quantity: item.reqQuantity,
                stoReqLineItemId: item.stoReqLineItemId,
                transferredQuantity: item.reqQuantity,
                transferredWeight: Number(weightChange.toFixed(4)),
                fineWeightChange: Number(fineWeightChange.toFixed(4)),
                selectedSerialNumbers: item.selectedSerialNumbers
            }
        });

        let payload = {
            incomingReqId: currentRequest.id,
            inventoryLineItems: lineItem,
            shipper_id: user.centerId,
            destination_id: currentRequest.requestedCenter,
            mts_delivery_challan_code: nanoid(),
            remarks: "",
            // delivery_challan_no: nanoid(),
            // total_gold_fine_weight: totalGoldFineWeight,
            // total_silver_fine_weight: totalSilverFineWeight,
            // is_mts_transfer: currentRequest.requestedCenter.value === "MTSOutbound" ? true : false,
            // mts_transfer_type: currentRequest.requestedCenter.value === "MTSOutbound" ? 'outbound' : '',
            // is_mts_updated: false,
        }

        let { data, error } = await execute(() => createStockTransferOrder(payload as unknown as IStocktranferData))

        if (!error) {
            notify('Stock transferred successfully!')
            clearPreviousRowDetails()
            execute(() => getStockRequest({}))
            execute(() => fetchInventory({ channelId: user.centerId! || '' }))

            onClose()
        }
    }
    const handleRejectRequest = async () => {
        const { error } = await execute(() => createOrUpdateStockRequest({ id: currentRequest.id, rejectRequest: true }))
        if (!error) {
            notify('Stock Request Rejected Successfully!');
            execute(() => getStockRequest({}))
            onClose()
        } else {
            notify(error.reason, 'error');
        }

    }

    return (
        <>
            <Container>
                <Table
                    editMode="row"
                    rows={rows}
                    getRowId={(row) => row.id}
                    columns={getInventoryColumns()}
                    checkboxSelection
                    disableRowSelectionOnClick
                    isRowSelectable={(params: GridRowParams) => params.row.isEditable}
                    onRowSelectionModelChange={handleRowSelectionModel}
                    rowSelectionModel={rowSelectionModel}
                />

                {/* <TextFieldGroup>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '325px' }}>
                    <Typographyfield>{'Total Gold fine Weight'}</Typographyfield> :
                    <TypographyValue>{totalGoldFineWeight} gm</TypographyValue>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', width: '325px' }}>
                    <Typographyfield>{'Total Silver Fine Weight'}</Typographyfield> :
                    <TypographyValue>{totalSilverFineWeight} gm</TypographyValue>
                </Box>
            </TextFieldGroup> */}

                <Stack width="100%" marginTop="25px" direction="row" justifyContent="flex-end" gap="10px" align-items="center">
                    <Button onClick={handleRejectRequest}>Reject</Button>
                    <Button color="primary" variant="contained" disabled={isDisabled} onClick={stockTransferOrder}>{currentRequest.status === REQUEST_STATUS.PENDING ? "Approve" : `Already ${currentRequest.status}`}</Button>
                </Stack>
            </Container>
        </>
    )
}